import React from "react";

import { NodeToolbar, Position, useViewport } from "@xyflow/react";

const TOOLBAR_OFFSET = 10;

type Props = {
  onMouseEnter: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave: React.MouseEventHandler<HTMLDivElement>;
  children: React.ReactNode;
};

export const NodeControlsToolbar: React.FC<Props> = ({
  onMouseEnter,
  onMouseLeave,
  children,
}) => {
  const { zoom } = useViewport();

  return (
    <NodeToolbar
      isVisible
      align="start"
      offset={TOOLBAR_OFFSET * zoom}
      position={Position.Right}
    >
      <div
        style={{ transform: `scale(${zoom})`, transformOrigin: "top left" }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </div>
    </NodeToolbar>
  );
};
